export const getLongreadCoverTextPosition = (posts: any[]) => {
    return posts?.map((post: any) => {
        if (post?.style === 'as_cover') {
            return post?.titlePosition || ''
        }
    });
}export const getLongreadCoverTextPosition = (posts: any[]) => {
    return posts?.map((post: any) => {
        if (post?.style === 'as_cover') {
            return post?.titlePosition || ''
        }
    });
}